import { Box, Typography, LinearProgress, Divider } from '@mui/material';
import React from 'react';
import { CitationScanningSx } from '../styles';

export interface CitationProgressCardProps {
  topCardTitle: string;
  topCardDescription: string;
  statusText: string;
  progressValue: number;
  bottomCardTitle: string;
  bottomCardIntro: string;
  features: string[];
}

export const CitationProgressCard = ({
  topCardTitle,
  topCardDescription,
  statusText,
  progressValue,
  bottomCardTitle,
  bottomCardIntro,
  features
}: CitationProgressCardProps) => {
  return (
    <Box sx={CitationScanningSx.outerContainer}>
      {/* Top Card */}
      <Box sx={CitationScanningSx.cardContainer}>
        <Typography sx={CitationScanningSx.topCardTitle}>
          {topCardTitle}
        </Typography>
        <Typography sx={CitationScanningSx.topCardDescription}>
          {topCardDescription}
        </Typography>
        <Typography sx={CitationScanningSx.scanningStatus}>
          {statusText}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progressValue}
          sx={CitationScanningSx.progressBar}
        />
      </Box>

      {/* Bottom Card */}
      <Box sx={CitationScanningSx.cardContainer}>
        <Typography sx={CitationScanningSx.bottomCardTitle}>
          {bottomCardTitle}
        </Typography>
        {bottomCardIntro && (
          <Typography sx={CitationScanningSx.bottomCardIntro}>
            {bottomCardIntro}
          </Typography>
        )}
        <Box sx={CitationScanningSx.featureList}>
          {features.map((feature, index) => (
            <React.Fragment key={index}>
              <Box key={index} sx={CitationScanningSx.featureItem}>
                <Box sx={CitationScanningSx.checkmarkCircle}>
                  <Box 
                    component="img"
                    src={process.env.PUBLIC_URL + '/static/images/icons/local-seo/checkmark-circle-blue.svg'}
                    alt="checkmark circle"
                    width={16}
                    height={16}
                  />
                </Box>
                <Typography sx={CitationScanningSx.featureText}>
                  {feature}
                </Typography>
              </Box>
              {index !== features.length - 1 && (
                <Divider orientation='horizontal' flexItem />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

